export const ICON_CONSTANTS = {
  NON_RETURNABLE_BLACK_NEW: 'NON_RETURNABLE_BLACK_NEW',
  NON_RETURNABLE_BLACK: 'NON_RETURNABLE_BLACK',
  INSTALLMENTS: 'INSTALLMENTS',
} as const

export const ICON_CONSTANTS_MAP: Record<keyof typeof ICON_CONSTANTS, string> = {
  [ICON_CONSTANTS.NON_RETURNABLE_BLACK_NEW]:
    'https://images.quince.com/3E3SxLDx3RwHCjQUxCn3Ip/815ab061c73c49c8bc87d0a949e163ef/nonReturnableBlackNew.inline.svg',
  [ICON_CONSTANTS.NON_RETURNABLE_BLACK]:
    'https://images.quince.com/RsgvVf4vhnazdnB6JiAi0/c1af2f8ee61783ab2dbb66fa9b621b39/nonReturnableBlack.inline.svg',
  [ICON_CONSTANTS.INSTALLMENTS]:
    'https://images.quince.com/31scCSt4NU4D7aoZfiFRsf/0486eab285d15ea0f16bf01812aeffd6/calendar.svg',
} as const
